import { animate, spring } from "motion";

export default class NavDesktop {
  constructor(navbar) {
    this.navbar = navbar;
    this.scrollOffset = 100;

    this.subNavs = $(this.navbar).find(
      ".page-navbar__menu .menu-item-has-children"
    );
    this.subNavs.on("mouseenter", this.mouseenter.bind(this));
    this.subNavs.on("mouseleave", this.mouseleave.bind(this));
    this.subNavs.on("focusin", this.mouseenter.bind(this));
    this.subNavs.on("focusout", this.mouseleave.bind(this));

    this.navItems = $(this.navbar).find("li a");
    this._detectNavActive();
    $(window).on("scroll", this._detectNavActive.bind(this));

    // shadow
    $(window).on("scroll", this._handleNavbarShadow.bind(this));
    this._handleNavbarShadow();
  }

  _handleNavbarShadow() {
    $(this.navbar).toggleClass("page-navbar--has-shadow", window.scrollY > 10);
  }

  _detectNavActive() {
    var scPos = $(window).scrollTop();

    this.navItems.each((index, element) => {
      var menuEl = $(element);
      var link = menuEl.attr("href");

      // is hash link
      if (link.indexOf("#") !== -1) {
        var linkHash = link.substring(link.indexOf("#"));
        var $anchorElement = $(linkHash);

        // has Anchor Element on same page
        if ($anchorElement.length) {
          if (
            scPos + this.scrollOffset > $anchorElement.offset().top &&
            scPos + this.scrollOffset <
              $anchorElement.offset().top + $anchorElement.height()
          ) {
            menuEl.parent("li").addClass("active");
          } else {
            menuEl.parent("li").removeClass("active");
          }
        }
      }
    });
  }

  mouseenter(event) {
    const sub = event.currentTarget.querySelector("ul.sub-menu");
    if (!sub) return;
    this.showSub(sub);
  }

  mouseleave(event) {
    const sub = event.currentTarget.querySelector("ul.sub-menu");
    if (!sub) return;
    this.hideSub(sub);
  }

  showSub(sub) {
    sub.previousElementSibling.setAttribute("aria-expanded", true);

    const translateX = sub.parentNode.closest("ul.sub-menu") ? "100%" : "0";

    animate(
      sub,
      {
        opacity: 1,
        pointerEvents: "auto",
        transform: `translateX(${translateX}) translateY(0)`,
      },
      { duration: 0.5, easing: spring() }
    );
  }

  hideSub(sub) {
    sub.previousElementSibling.setAttribute("aria-expanded", false);

    const translateX = sub.parentNode.closest("ul.sub-menu") ? "100%" : "0";
    animate(
      sub,
      {
        opacity: 0,
        pointerEvents: "none",
        transform: `translateX(${translateX}) translateY(15px)`,
      },
      { duration: 0.5, easing: spring() }
    );
  }
}
